import { SHOW_TOASTER, RESET_TOASTER } from './constants';

interface Payload {
  timeout: number;
  msg: string;
  refresh?: boolean;
  success: boolean;
}

export const showToaster = (payload: Payload) => ({
  type: SHOW_TOASTER,
  data: payload,
});

export const resetToaster = () => ({
  type: RESET_TOASTER,
});
